<div class="bg-primary text-center">
  <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">
    {{ 'validationSummary' | translate}}
  </h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-center">
  <div class="w-100 ValidationErrors">
    <ul>
      <li *ngFor="let error of ValidationErrors">
        <span>{{error}}</span>
        <!-- <span class="m-l-10">*</span> -->
      </li>
    </ul>
  </div>
</mat-dialog-content>